import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';

export class CollapsingContainer extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      showAll: false,
      childContainerHeight: 0
    };

    this.childContainer = null;
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount () {
    const childContainerHeight = get(this, 'childContainer.scrollHeight');
    this.setState({ childContainerHeight });
  }

  handleClick (e) {
    e.preventDefault();
    const { collapsedHeight } = this.props;
    const content = e.currentTarget.parentElement.parentElement.previousElementSibling;
    const collapsedHeightPx = collapsedHeight + 'px';

    if (collapsedHeightPx === content.style.maxHeight) {
      content.style.maxHeight = content.scrollHeight + 'px';
    } else {
      content.style.maxHeight = collapsedHeightPx;
    }

    this.setState({
      showAll: !this.state.showAll
    });
  }

  render () {
    const { showAll, childContainerHeight } = this.state;

    const {
      collapsedHeight,
      children,
      hasFade,
      showText = <FormattedMessage
        id="listing.collapsing_container.show_all"
        defaultMessage="Show all"
      />,
      hideText = <FormattedMessage
        id="listing.collapsing_container.show_less"
        defaultMessage="Show less"
      />,
      className = '',
      animated = true,
      grayBackground = false,
      textSmall = false
    } = this.props;

    const showCollapseButtons = childContainerHeight > collapsedHeight;

    const styles = {
      maxHeight: collapsedHeight + 'px'
    };

    return (
      <div className={classnames('show-all-container', { collapsed: !showAll, animated, 'gray-background': grayBackground })}>
        <div
          className={classnames('content formatted', className, { 'show-content': showAll })}
          style={styles}
          ref={ (ref) => { this.childContainer = ref; } }
        >
          {children}
        </div>

        { showCollapseButtons
          && <div className="group-bottom">
            { !!hasFade && <div className="faded" /> }

            <div className={classnames('button-box', { 'hide-button': showAll })}>
              <button
                onClick={this.handleClick}
                type="button"
                style={{ position: 'relative', top: textSmall ? '-8px' : '-2px', color: '#6A6E7A' }}
              >
                <div className={textSmall ? 'text-small' : ''}>
                  <span>{ showAll ? hideText : showText}</span>
                </div>
              </button>
            </div>
          </div>
        }
      </div>
    );
  }
}

CollapsingContainer.propTypes = {
  collapsedHeight: PropTypes.number,
  children: PropTypes.node,
  hasFade: PropTypes.bool,
  showText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  hideText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  className: PropTypes.string,
  animated: PropTypes.bool,
  grayBackground: PropTypes.bool
};
